export default __webpack_public_path__ + "4015e6fe104d7e61ca37436de715dd1e.woff";